import React, { useState, useEffect, useRef } from "react";
import { Form, Row, Col, Card, Input, Button } from "antd";
import { useHistory } from "react-router-dom";
import { serverUrl } from "../../constants/config";
import { Link } from "react-router-dom";
import { clock } from "../../utility/clock";
import { timeStamp } from "../../utility/timestamp";
import { v4 as uuidv4 } from "uuid";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import MenuIcon from "../../assets/images/menu.png";
import POSLogo from "../../assets/images/cwPosLogo.png";
import Axios from "axios";
import db from "../../database";
import data from "../../constants/opentillClosetill.json";
import "../style.css";
import _ from "lodash";

const OpenTill1 = () => {
  const history = useHistory();
  const dynamicHeight = 0.5625;
  const tokens = JSON.parse(localStorage.getItem("tokens"));
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const tillaccess = JSON.parse(tillData.tillAccess.userAccessController);
  const tillLayout = parseInt(tillaccess?.layout === null || undefined ? 1 : tillaccess?.layout);
  const [inputValue,setInputValue] = useState({});
  const [inputAmount, setInputAmount] = useState(0);

  const [currencyType, setCurrencyType] = useState({
    currSymbolLeft: "₹",
    currSymbolRight: "",
    stdPrecision: 2,
  });

  useEffect(() => {
    const tillSession = localStorage.getItem("tillSession");
    if (tillSession) {
      if (JSON.parse(tillSession).tillStatus === "open") history.push(tillLayout === 2 && tillaccess?.dineIn === "Y" ? "/table-management" : "/pos");
    } else {
      db.tillRegistrations.toArray().then((reg) => {
        if (reg.length > 0) {
          const curList = reg[0].tillAccess[0].csBunit.csCurrency;
          const csCurrencyId = curList.csCurrencyId;
          localStorage.setItem("csCurrencyId", csCurrencyId);
          setCurrencyType({
            currSymbolLeft: curList.symbolrightside ? "" : curList.currSymbol,
            currSymbolRight: curList.symbolrightside ? curList.currSymbol : "",
            stdPrecision: curList.stdPrecision,
          });
        }
      });
    }
  }, []);

  const [denominations, setDenominations] = useState([]);

  useEffect(() => {
    const modifiedCurrenciesList = currenciesList[0].denominations?.map((denomItem, denomIndex) => ({
      ...denomItem,
      count : 0,
      amount: 0
    }))
    setDenominations([...modifiedCurrenciesList]);
  }, [])


  const currentDate = new Date().toLocaleDateString();
  const [displayClock, setDisplayClock] = useState("");
  useEffect(() => {
    setDisplayClock(clock());
    const timerId = setInterval(() => setDisplayClock(clock()), 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  const [totalAmount, setTotalAmount] = useState(0);

  const onFieldInput = (e) => {
    const { name, value } = inputValue;
    const denominationName = parseInt(name);
    const denominationValue = parseInt(value);
    const denominationAmount = denominationValue;
    // const di = denominations.findIndex((d) => d.value === denominationName);
    denominations[0].count = 1;
    denominations[0].amount = isNaN(denominationAmount) ? 0 : denominationAmount;
    // let total = 0;
    // denominations.forEach((denom) => {
    //   total += denom.amount;
    // });
     setTotalAmount(value);
    setDenominations([...denominations]);
    setInputAmount(0);
  };
  
  const confirmBtnRef = useRef(null);
  const cancelBtnRef = useRef(null);

  const excuteOpenTill = () => {
    confirmBtnRef.current.disabled = true;
    cancelBtnRef.current.disabled = true;
    const tillSessionId = uuidv4().replace(/-/g, "").toUpperCase();
    const openTillData = {
      tillSessionId: tillSessionId,
      tillStatus: "open",
      openingTime: timeStamp(),
      closingTime: null,
      openingCashDenominations: denominations,
      closingCashDenominations: null,
      openingCash: totalAmount,
      closingCash: null,
      totalOpeningAmount: totalAmount,
      totalClosingExpectedAmount: null,
      totalClosingTransactions: null,
      totalClosingAmount: null,
    };
    console.log(openTillData)
    localStorage.setItem("tillSession", JSON.stringify(openTillData));
    if (db.logConfiguration.toArray().then((fetched) => {
      fetched.map((item) => {
        item.dayOpening.filter((item) => item.log === "Y").length > 0;
      });
    })) { 
      const timeMark = timeStamp();
      const currentDate = new Date().toLocaleDateString("zh-Hans-CN");
      const dayOpeningArray = [];
      dayOpeningArray.push(`{
        type: "DON",
        action: "LOG",
        description: "${timeMark}",
        date: "${currentDate}",
        time: "${timeMark}",
        orderNo: "",
        remarks: "",
      }`)
      Axios({
        url: serverUrl,
        method: "POST",
        data: {
          query: `mutation {
          upsertPOSLog(order: {
              tillId: "${tillData.tillAccess.cwrTill.cwrTillID}"
              userId: "${tillData.tillAccess.csUserId}" 
              bUnitId: "${tillData.tillAccess.csBunit.csBunitId}", 
              lines: [${dayOpeningArray}]
            }) {
            status   
            message
          }
        }`,
        },
        headers: {
          "Content-Type": "Application/json",
          Authorization: `${tokens.token_type} ${tokens.access_token}`,
        },
      })
    }
    confirmBtnRef.current.disabled = false;
    cancelBtnRef.current.disabled = false;
    history.push(tillLayout === 2 && tillaccess?.dineIn === "Y" ? "/table-management" : "/pos");
  };

  const focusFirstElement = () => {
    setTimeout(()=>{
      cancelBtnRef.current.focus();
    },100);
  };

  const resetFocus = (index) => {
    if(index+1 === denominations.length){
      focusFirstElement();
    }
  };

  const handleHome = () => {
    history.push("/dashboard");
  }

  return (
    <div style={data.openTill.mainContainer}>
      <Row style={{ height: `${3.7 * dynamicHeight}vw` }}>
        <Col span={2}>
          <img src={MenuIcon} style={data.openTill.header.menuIcon} alt="" />
        </Col>
        <Col span={10}>
          <label style={data.openTill.header.posHeadLabel}>{tillData.tillAccess.csBunit.name}</label>
        </Col>
        <Col span={8}>
          <label style={data.openTill.header.timeFmt}>OPEN TILL</label>
        </Col>
        <Col span={4} style={data.openTill.header.right}>
          <img src={POSLogo} style={data.openTill.header.posLogoIcon} alt="" onClick={handleHome}/>
        </Col>
      </Row>
      <div style={data.openTill.mainCardContainer}>
        <Row gutter={10}>
          <Col span={18}>
            <Card bodyStyle={{ padding: 10 }} style={{ borderRadius: "3px" }}>
              <Card key="z" style={data.openTill.mainCardFirst} bodyStyle={{ padding: 0 }}>
                <Row style={{ padding: 10 }}>
                  <Scrollbars autoHide className="tillScroll">
                  <Row style={{ marginBottom: "2%" ,height:"70vh",justifyContent:"center",display:"flex",alignItems:"center"}}>
                        <Col span={8} style={data.openTill.colAlign}>
                        </Col>
                        <Col span={8} style={data.openTill.colAlign}>
                          <div style={data.openTill.calInputDiv}>
                            <Form.Item style={{width:"100%"}}>
                            <div style={{textAlign:"left",paddingBottom:"10px"}}>Enter Amount</div>
                              <Input tabIndex={0} style={{"padding": "2px","borderRadius": "5px","border": "1px solid #ebeded","boxShadow": "none",height:"6vh"}} onChange={(e)=>{setInputValue(e.target);setInputAmount(e.target.value)}} value={inputAmount}/>
                            </Form.Item>
                          </div>
                          <div  style={data.openTill.calInputDiv}>
                          <Button tabIndex={1} className="focusButtonsTill" ref={confirmBtnRef} style={{"width": "100%","marginLeft": "2%","backgroundColor": "#0C173A","color": "#ffffff","fontSize": "100%","border": "none",}} onClick={onFieldInput} >
                            Add Amount
                          </Button>
                          </div>
                        </Col>
                        <Col span={8} style={data.openTill.colAlign}>
                        </Col>
                  </Row>
                    <span tabIndex={0}></span>
                  </Scrollbars>
                </Row>
              </Card>
            </Card>
          </Col>
          <Col span={6}>
            <Card bodyStyle={{ padding: 10 }} style={data.openTill.opentillRightCard}>
              <Link to="/dashboard">
                <Button tabIndex={1} className="focusButtonsTill" ref={cancelBtnRef} style={data.openTill.btnCancel}>
                  Cancel
                </Button>
              </Link>
              <Button tabIndex={1} className="focusButtonsTill" ref={confirmBtnRef} style={data.openTill.btnConfirm} onClick={excuteOpenTill}>
                Confirm
              </Button>
              <p style={data.openTill.emptyP} />
              <p style={data.openTill.emptyP}>Opened On</p>
              <div style={{ marginBottom: "0.5rem" }}>
                <span style={data.openTill.currentDate}>{currentDate}</span>
                <span style={data.openTill.displayClock}>{displayClock}</span>
              </div>
              <Form>
                <Form.Item style={{ marginBottom: "0.5rem" }}>
                  <p style={data.openTill.transactionsAmt}>Total Amount</p>
                  <Input
                    tabIndex={-1}
                    value={`${currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""} ${parseFloat(totalAmount).toFixed(currencyType.stdPrecision)} ${currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}`}
                    readOnly={true}
                    className="transactionAmtInput"
                  />
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default OpenTill1;
